import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 text-slate-600">
      <h1 className="text-2xl font-bold text-slate-900">Page introuvable</h1>
      <Link to="/" className="text-blue-600 hover:underline">
        Retour à l'accueil
      </Link>
    </div>
  );
}
